import type { TabConfig } from "@/components/shared/UniversalDetailPage/types/tab-types";
import type { Email_Campaigns } from "@/src/gql/graphql";

// ============================================================================
// EMAIL CAMPAIGN DETAIL TABS CONFIGURATION
// ============================================================================
// Details tab renders generically from the config `fields` map (no custom
// component) via FieldsTabContent — the same generic renderer other entities
// use. Modeled on social-media-post-detail-tabs.ts.
// ============================================================================

export const emailCampaignDetailTabs: TabConfig<Email_Campaigns>[] = [
  {
    id: "details",
    label: "Details",
    icon: "Mail",
    variant: "blue",
    group: "core",
    priority: 1,
    content: {
      type: "fields",
      layout: "grid",
      sections: [
        {
          id: "core",
          title: "Campaign",
          fields: ["name", "subject", "status", "brand"],
          layout: "grid",
          gridColumns: 2,
        },
        {
          id: "sender",
          title: "Sender",
          fields: ["from_name", "from_email", "reply_to"],
          layout: "grid",
          gridColumns: 2,
        },
        {
          id: "scheduling",
          title: "Scheduling",
          fields: ["scheduled_at", "sent_at"],
          layout: "grid",
          gridColumns: 2,
        },
        {
          id: "engagement",
          title: "Engagement",
          fields: ["recipients_count", "sent_count", "opened_count", "clicked_count"],
          layout: "grid",
          gridColumns: 2,
        },
      ],
    },
  },
];

export const emailCampaignDetailDefaultTab = "details";
